import ApplicationModel, { attr } from '../ApplicationModel';
import { type AssistantMessageAttributes } from './generated/AssistantMessageAttributes';
import { model } from '../modelBuilder';

interface AssistantMessage extends AssistantMessageAttributes {}

@model
class AssistantMessage extends ApplicationModel {
  // Start auto-generated
  static typename: 'AssistantMessage' = 'AssistantMessage';
  get typename(): 'AssistantMessage' {
    return 'AssistantMessage';
  }

  static internalTypename: 'Assistant::Message' = 'Assistant::Message';
  get internalTypename(): 'Assistant::Message' {
    return 'Assistant::Message';
  }

  static fields = {
    attachmentsCount: attr({ readable: true }),
    chatId: attr({ readable: true }),
    content: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    parentId: attr({ readable: true }),
    reasoning: attr({ readable: true }),
    role: attr({ readable: true }),
    safe: attr({ readable: true }),
    scope: attr({ readable: true, json: true }),
    toolCallsCount: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    chat: attr.belongsTo({ readable: true, typename: 'AssistantChat' }),
    attachments: attr.hasMany({ readable: true }),
    toolCalls: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  // Whether the message is currently receiving a streamed content.
  set active(newActive: boolean) {
    this.setAttribute('active', newActive);
  }
  get active(): boolean {
    return this.getAttribute('active') ?? false;
  }
}

export default AssistantMessage;
